import { IconBase, IconComponent } from './BaseIcon';

export const ShirtPile: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M2.03 28.06h28v2h-28zm0-4h28v2h-28zm0-4h28v2h-28zM26.82 4.07 5.24 4 1.76 18h28.56Zm-6.19 2a4.89 4.89 0 0 1-4.6 3 4.88 4.88 0 0 1-4.59-3ZM6.8 6h2.48A7.07 7.07 0 0 0 22.8 6h2.46l2.5 10H4.31Z" />
  </IconBase>
);
